import { BaseModel } from "@blue-chip/core";
import Invoice from "./Invoice";
import Spec from "./Spec";

export default class InvoiceSpec extends BaseModel {
  static get belongsTo() {
    return [Invoice, Spec];
  }
}
